export default __webpack_public_path__ + "assets/password.7be5fdf2.svg";